import React, { useEffect, useState } from "react";
import { Card, Tooltip } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { numberWithCommas } from "shared/services/Utility";

interface SummaryCardProps {
    item: {
        label: string;
        key: string;
        tooltip: string | null;
        value: number | null;
        previousValue: number | null;
        percentChange: number | null;
        delta: string | null;
    };
}

const SummaryCard: React.FC<SummaryCardProps> = ({ item }) => {
    const [deltaValues, setDeltaValues] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        let enumValues = localStorage.getItem("enumValues") as any;
        if (enumValues) {
            enumValues = JSON.parse(enumValues);
            const _deltaValues = enumValues.find(
                (item: any) => item.propertyName === "CHART_DELTA"
            );
            const deltaMap = _deltaValues?.keyAndDisplayValueList?.reduce((acc: any, curr: any) => {
                acc[curr.key] = curr.value;
                return acc;
            }, {});
            setDeltaValues(deltaMap || {});
        }
    }, []);

    return (
        <Card style={{ marginBottom: "16px", height: "100%" }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "8px",
                }}
            >
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                    {item.label}
                </span>
                <Tooltip title={item.tooltip}>
                    <InfoCircleOutlined style={{ marginLeft: "8px" }} />
                </Tooltip>
            </div>
            <div style={{ fontSize: "28px", fontWeight: "bold" }}>
                    <span>{numberWithCommas(item.value)}</span>
            </div>
            {item.previousValue !== null && (
                <div style={{ fontSize: "14px", color: "#888" }}>
                    vs prev {numberWithCommas(item.previousValue)} {" "}
                    {item.delta === "POSITIVE" ? (
                        <span style={{ color: "green" }}>
                            <ArrowUpOutlined /> {item.percentChange ? `+(${item.percentChange}%)` : ""}
                        </span>
                    ) : item.delta === "NEGATIVE" ? (
                        <span style={{ color: "red" }}>
                            <ArrowDownOutlined /> ({item.percentChange}%)
                        </span>
                    ) : item.delta === "NEUTRAL" ? (
                        <span style={{ color: "gray" }}>
                            {deltaValues[item.delta]}
                        </span>
                    ) : null}
                </div>
            )}
        </Card>
    );
};

export default SummaryCard;
